// extracted by mini-css-extract-plugin
module.exports = {"expenseDescription":"style_expenseDescription__2XJLH","hidden":"style_hidden__FsUHk"};